import type { PayStatement } from "@/payroll/ai-script/statement/statement-schema";

export const STATEMENT_RELEASE_REASON = {
  awaitingSend: "awaiting_send",
  periodOpen: "period_open",
} as const;

export type StatementReleaseReason =
  (typeof STATEMENT_RELEASE_REASON)[keyof typeof STATEMENT_RELEASE_REASON];

export interface IAiScriptStatementResponse {
  statement: PayStatement | null;
  linked: boolean;
  released?: boolean;
  release_reason?: StatementReleaseReason;
  statement_run_id?: string;
}
